var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.458,
    height: 29.672,
    viewBox: "0 0 32.458 29.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(0 -20.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232324",
    "data-name": "Group 232324",
    transform: "translate(0 20.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57542",
    "data-name": "Path 57542",
    d: "M219.893,333.382a1.668,1.668,0,1,0,0,3.336,1.669,1.669,0,0,0,0-3.336Z",
    transform: "translate(-203.664 -312.531)",
    fill: "#fd3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57543",
    "data-name": "Path 57543",
    d: "M31.668,47.645a5.7,5.7,0,0,0,.013-5.765l-10.449-18.1a5.757,5.757,0,0,0-10-.007L.775,41.893a5.779,5.779,0,0,0,5,8.661H26.65A5.746,5.746,0,0,0,31.668,47.645ZM29.4,46.337a3.153,3.153,0,0,1-2.756,1.595H5.773A3.11,3.11,0,0,1,3.05,46.37a3.157,3.157,0,0,1-.007-3.183L13.506,25.079a3.142,3.142,0,0,1,5.458.007L29.419,43.194A3.115,3.115,0,0,1,29.4,46.337Z",
    transform: "translate(0 -20.882)",
    fill: "#fd3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57544",
    "data-name": "Path 57544",
    d: "M219.013,157.223a1.814,1.814,0,0,0-1.288,1.822c.04.527.073,1.061.113,1.588.113,2.008.227,3.977.34,5.985a1.222,1.222,0,0,0,1.248,1.174,1.247,1.247,0,0,0,1.248-1.214c0-.414,0-.794.04-1.214.073-1.288.153-2.576.227-3.863.04-.834.113-1.668.153-2.5a2.06,2.06,0,0,0-.153-.834A1.672,1.672,0,0,0,219.013,157.223Z",
    transform: "translate(-203.198 -148.082)",
    fill: "#fd3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1b73e9b0c4aede5261ab6c4b6d379b25.svg";
export { ForwardRef as ReactComponent };